'use client';

var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var months = [
    '',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
var nth = function (d) {
    if (d > 3 && d < 21)
        return 'th';
    switch (d % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
};
var convertDateTime = function (time, type) {
    if (type === void 0) { type = 0; }
    var date = new Date(time);
    var day = date.getDate();
    var dayName = days[date.getDay()];
    var month = date.getMonth() + 1;
    var monthName = months[month];
    var year = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    var addZero = function (date) { return String(date).padStart(2, '0'); };
    switch (type) {
        case 0: {
            // 30/10/2022 07:30
            var formatDate = addZero(day) + '/' + addZero(month) + '/' + year;
            var formatTime = addZero(hours) + ':' + addZero(minutes);
            return "".concat(formatDate, " ").concat(formatTime);
        }
        case 1: {
            // Friday, 15 Oct 2022
            return "".concat(dayName, ", ").concat(day, " ").concat(monthName, " ").concat(year);
        }
        case 2: {
            // Oct 5th, 2022
            return "".concat(monthName, " ").concat(day).concat(nth(day), ", ").concat(year);
        }
        case 3: {
            // 06:30
            return "".concat(String(hours).padStart(2, '0'), ":").concat(String(minutes).padStart(2, '0'));
        }
        case 4: {
            // 15 Wed, 2022
            return "".concat(day, " ").concat(monthName.slice(0, 3), ", ").concat(year);
        }
        case 5: {
            // Wed 15, 2022
            return "".concat(monthName.slice(0, 3), " ").concat(day, ", ").concat(year);
        }
        case 6: {
            // 2022-10-18 11:04:20
            return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
        }
        case 7: {
            // 30/10/2022
            var formatDate = addZero(day) + '/' + addZero(month) + '/' + year;
            return formatDate;
        }
        default:
            return '';
    }
};
var formatInvalidDate = function (dateTime, format) {
    switch (format) {
        case 'YYYY-MM-DD HH:MM:SS':
            return dateTime.slice(0, 10);
        default:
            return '';
    }
};
var convertDateToISO = function (dateString) {
    // Regular expression to match the exact format YYYY-MM-DD HH:mm:ss
    var regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
    if (regex.test(dateString)) {
        // Replace the space with 'T' to convert to ISO 8601 format
        return dateString.replace(' ', 'T');
    }
    else {
        return dateString;
    }
};
var dateToString = function (dateTime, format) {
    if (format === void 0) { format = 'DD/MM/YYYY'; }
    var date;
    if (!dateTime) {
        date = new Date();
    }
    else {
        if (typeof dateTime === 'string') {
            var a = dateTime.split(/[^0-9]/);
            date = new Date(Number(a[0]), Number(a[1]) - 1, Number(a[2]), Number(a[3]), Number(a[4]), Number(a[5]));
        }
        else {
            date = new Date(dateTime * 1000);
        }
    }
    var rawDay = date.getUTCDate();
    var rawMonth = date.getUTCMonth() + 1;
    var day = rawDay < 10 ? "0".concat(rawDay) : rawDay;
    var month = rawMonth < 10 ? "0".concat(rawMonth) : rawMonth;
    var rawHours = date.getUTCHours();
    var rawMinutes = date.getUTCMinutes();
    var hours = rawHours >= 10 ? rawHours : "0".concat(rawHours);
    var minutes = rawMinutes >= 10 ? rawMinutes : "0".concat(rawMinutes);
    switch (format) {
        case 'DD/MM/YYYY HH:MM':
            return day + '/' + month + '/' + date.getUTCFullYear() + ' ' + hours + ':' + minutes;
        case 'DD/MM/YYYY':
            return day + '/' + month + '/' + date.getUTCFullYear();
        default:
            return (day + '-' + month + '-' + date.getUTCFullYear() + ' ' + hours + ':' + minutes + ':' + date.getSeconds());
    }
};

export { convertDateTime, convertDateToISO, dateToString, formatInvalidDate };
//# sourceMappingURL=time.js.map
